import { FC } from 'react';

import ListItem from './ListItem';
import { ListWrapper } from './Wrapper';
import { ListProps } from './types';

const List: FC<ListProps> = ({ list, customIcon }) => (
  <ListWrapper>
    {list.map(item => (
      <ListItem key={item.title} {...{ ...item, customIcon }} />
    ))}
  </ListWrapper>
);
export default List;
